var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoiconthecrew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 62,
    fill: "white",
    stroke: "#2D2B2B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 62.5,
    r: 60,
    fill: "black",
    stroke: "#2D2B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.085 76.7402C37.4954 77.7201 34.556 78.21 31.2666 78.21C20.4886 78.21 15.0996 72.9959 15.0996 62.5679C15.0996 52.6997 20.4886 47.7656 31.2666 47.7656C34.556 47.7656 37.4954 48.2555 40.085 49.2354V54.2744C37.4954 53.1546 34.696 52.5947 31.6865 52.5947C24.4779 52.5947 20.8735 55.9191 20.8735 62.5679C20.8735 69.7765 24.4779 73.3809 31.6865 73.3809C34.696 73.3809 37.4954 72.821 40.085 71.7012V76.7402ZM45.334 77.958V47.9756H58.9814C65.1123 47.9756 68.1777 50.6561 68.1777 56.0171C68.1777 59.6424 65.7912 62.6449 61.0181 65.0244L70.5293 78H63.5166L54.3833 64.9194V62.3789C59.7023 61.4691 62.3618 59.4045 62.3618 56.1851C62.3618 53.9735 61.116 52.8677 58.6245 52.8677H51.0029V77.958H45.334ZM70.7603 47.9756H76.4082L79.6206 69.5386L87.4312 47.9756H92.7852L100.092 68.6987L103.493 47.9756H108.973L103.325 78H98.0342L89.7827 54.4424L80.9224 78H75.6943L70.7603 47.9756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoiconthecrew);
export default __webpack_public_path__ + "static/media/logoiconthecrew.411c8a5693be5a997d2af77e6544906b.svg";
export { ForwardRef as ReactComponent };